import Vue from 'vue'
import iconPrice from './IconPrice'
import fixedTab from './FixedTab'
import footerBtn from './FooterBtn'
import backSpell from './BackSpell'

function globalComponent() {
    if (globalComponent.installed) {
        return
    }
    Vue.component('iconPrice', iconPrice)
    Vue.component('fixedTab', fixedTab)
    Vue.component('footerBtn', footerBtn)
    Vue.component('backSpell', backSpell)
}

export default globalComponent
